import React from 'react';
import { motion } from 'framer-motion';

export default function FinalCTA() {
  const scrollToInquiry = () => {
    document.getElementById('inquiry')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-32 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-slate-50 opacity-50" />
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
            Ready for a different <br /><span className="text-indigo-600">Event Experience?</span>
          </h2>
          <p className="text-xl text-slate-600 mb-10 font-light max-w-2xl mx-auto">
            Join the exclusive list of events using Kuhako.pro. Managed setup, professional results, lasting memories.
          </p>
          <button 
            onClick={scrollToInquiry}
            className="bg-slate-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-slate-800 transition-all shadow-xl shadow-slate-900/20 active:scale-95"
          >
            Request Access Today
          </button>
          <p className="mt-6 text-sm text-slate-500 font-medium tracking-wide uppercase">Limited event slots available for 2026</p>
        </motion.div>
      </div>
    </section>
  );
}